import { createApiClient } from "../utilities/apiClient";
import { useQuery } from "@tanstack/react-query";
import { ICertData } from "../declarations";

const getCertData = async (guid: string): Promise<ICertData[]> => {
    const axiosCertData = createApiClient();
    const response = await axiosCertData.get(
        `/api/Cert/GetCertData/${guid}`,
    );
    return response.data;
};

export const useGetCertData = (guid: string) =>
    useQuery({
        queryKey: [
            "GetCertData",
            {
                id: guid ?? null,
            },
        ],
        queryFn: () => {
            return getCertData(guid);
        },
        enabled: guid !== null && guid !== "",
        refetchOnWindowFocus: true,
        retry: false,
    });
